// Module
var code = "<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model\" placeholder=\"{{::'Anytime' | translate }}\" ng-change=\"$ctrl.onChange()\"/> ";
// Exports
module.exports = code;